module.exports = __webpack_public_path__ + "img/emp-not-invited-learn-more.623704e7.png";